import { v4 as uuidv4 } from 'uuid'

export function generateUID() {
  const uid = uuidv4() // ########-####-####-####-############
  return `${uid.slice(0, 8)}${uid.slice(9, 13)}${uid.slice(14, 18)}${uid.slice(19, 23)}${uid.slice(24, 36)}`
}
